import { addDays } from 'date-fns/addDays';
import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { BulkMlosValidation } from 'uplisting-frontend/validations';

export default class BulkMlosRepositoryService extends BaseRepositoryService<
  ModelRegistry['bulk-mlos']
> {
  recordName = 'bulk-mlos';
  implementMethods = ['buildChangeset', 'createRecord'];

  validation = BulkMlosValidation;

  get defaultParams() {
    return {
      from: new Date(),
      to: addDays(new Date(), 1),
    };
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/bulk-mlos': BulkMlosRepositoryService;
  }
}
